module.exports = __webpack_public_path__ + "static/media/432226377_661706966035752_5949290160229295173_n.b1a6dbfc.jpg";